"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.socialSites = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _shareAltRegular = _interopRequireDefault(require("./icons/share-alt-regular.svg"));

var _shareAltLight = _interopRequireDefault(require("./icons/share-alt-light.svg"));

var _envelopeSolid = _interopRequireDefault(require("./icons/envelope-solid.svg"));

var _facebookFBrands = _interopRequireDefault(require("./icons/facebook-f-brands.svg"));

var _linkedinInBrands = _interopRequireDefault(require("./icons/linkedin-in-brands.svg"));

var _pinterestPBrands = _interopRequireDefault(require("./icons/pinterest-p-brands.svg"));

var _tumblrBrands = _interopRequireDefault(require("./icons/tumblr-brands.svg"));

var _twitterBrands = _interopRequireDefault(require("./icons/twitter-brands.svg"));

var _instagramBrands = _interopRequireDefault(require("./icons/instagram-brands.svg"));

require("./social-icon.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var socialSites = ['share', 'shareLight', 'email', 'facebook', 'linkedin', 'pinterest', 'tumblr', 'twitter', 'instagram'];
exports.socialSites = socialSites;

var iconForSite = function iconForSite(site) {
  switch (site) {
    case 'share':
      return _shareAltRegular["default"];

    case 'shareLight':
      return _shareAltLight["default"];

    case 'email':
      return _envelopeSolid["default"];

    case 'facebook':
      return _facebookFBrands["default"];

    case 'linkedin':
      return _linkedinInBrands["default"];

    case 'pinterest':
      return _pinterestPBrands["default"];

    case 'tumblr':
      return _tumblrBrands["default"];

    case 'twitter':
      return _twitterBrands["default"];

    case 'instagram':
      return _instagramBrands["default"];

    default:
      return function () {
        return null;
      };
  }
};
/**
 * A Glowforge-standard icon representing the given social site. The general
 * approach is to use a field of the appropriate brand-color (e.g. facebook
 * blue, pinterest red) with a minimal logo bug over top. There are several
 * appearance variants provided:
 *
 * round - a round field dot
 * square - a square with rounded corners
 * clear - transparent background with the logo inheriting the current css
 *         `color`. This is useful for overlays.
 *
 * @param props
 * @param props.className - Applied to the div wrapping the svg
 * @param props.site - which social site?
 * @param props.size - standard sizes small, medium, or large
 * @param props.appearance - available styles square, round, clear
 * @returns {*}
 * @constructor
 */


var SocialIcon = function SocialIcon(_ref) {
  var className = _ref.className,
      site = _ref.site,
      size = _ref.size,
      appearance = _ref.appearance;
  var Icon = iconForSite(site);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('SocialIcon', site, size, appearance, className)
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    className: "icon"
  }));
};

SocialIcon.propTypes = {
  className: _propTypes["default"].string,
  site: _propTypes["default"].oneOf(socialSites).isRequired,
  size: _propTypes["default"].oneOf(['small', 'medium', 'large', 'fit']),
  appearance: _propTypes["default"].oneOf(['square', 'round', 'clear'])
};
SocialIcon.defaultProps = {
  className: '',
  size: 'medium',
  appearance: 'square'
};
var _default = SocialIcon;
exports["default"] = _default;